import React from "react";
import { useTranslation } from "react-i18next";
import { AlertSpg, GridSpg, TableSkeleton } from "@duosoftbg/nacid-components";
import { Box, Grid } from "@mui/material";
import GlobalMessageListTable from "./GlobalMessageListTable";
import ViewGlobalMessageDialog from "./dialog/ViewGlobalMessageDialog";
import SaveGlobalMessageDialog from "./dialog/SaveGlobalMessageDialog";
import DeleteGlobalMessageDialog from "./dialog/DeleteGlobalMessageDialog";
import ChangeGlobalMessageVisibilityDialog from "./dialog/ChangeGlobalMessageVisibilityDialog";

const GlobalMessageList = ({ records, total, isLoading, onPageOrOrderChange, blockTable, group, fetch }) => {
  const { t } = useTranslation();

  const showTable = () => {
    if (!(total > 0)) {
      return (
        <AlertSpg mt={10} severity="info">
          {t("m.empty.list")}
        </AlertSpg>
      );
    }
    return (
      <>
        <ViewGlobalMessageDialog></ViewGlobalMessageDialog>
        <SaveGlobalMessageDialog filterFn={fetch} />
        <DeleteGlobalMessageDialog filterFn={fetch} records={records} total={total} />
        <ChangeGlobalMessageVisibilityDialog filterFn={fetch} />
        <GlobalMessageListTable
          records={records}
          total={total}
          onPageOrOrderChange={onPageOrOrderChange}
          blockTable={blockTable}
          group={group}
          fetch={fetch}
        />
      </>
    );
  };

  return (
    <Box>
      <Grid container spacing={1}>
        <GridSpg item xs={12}>
          {isLoading ? <TableSkeleton /> : showTable()}
        </GridSpg>
      </Grid>
    </Box>
  );
};

export default GlobalMessageList;
